/**
 * NotFoundPage Component
 * 404 error page for invalid routes
 */

import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '../../components/ui/Button/Button';
import { Icon } from '../../components/ui/Icon/Icon';
import { ArrowIcons } from '../../components/ui/Icon/generalIcons';
import styles from './NotFoundPage.module.css';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate({ to: '/' });
  };

  return (
    <div className={styles.notFoundPage}>
      <div className={styles.notFoundPage__content}>
        {/* 404 Display */}
        <div className={styles.notFoundPage__code}>404</div>

        {/* Error Message */}
        <h1 className={styles.notFoundPage__title}>Page not found</h1>
        <p className={styles.notFoundPage__description}>
          Sorry, we couldn't find the page you're looking for.
        </p>

        {/* Actions */}
        <div className={styles.notFoundPage__actions}>
          <Button
            variant="primary"
            size="lg"
            onClick={handleGoHome}
            leftIcon={<Icon icon={ArrowIcons.Left} size="md" />}
          >
            Go back home
          </Button>
        </div>
      </div>
    </div>
  );
};
